import React, { useRef, useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import oncommit from "../../assets/hemmexus.png";
import avatarVideo from "../../assets/avatares/locucion-violet-2.webm";
import avatarVideoMp4 from "../../assets/avatares/locucion-violet-2.mp4";
import manuelVideo from "../../assets/avatares/juan-consulta.webm";
import manuelVideoMp4 from "../../assets/avatares/juan-consulta.mp4";
import flechaAvanzar from "../../assets/right-arrow.svg";
import { modalPresentacionManuel } from "../../utils/logger";
import ScenarioBar from "../../components/ScenarioBar";
import NextButton from "../../components/NextButton";
import avatarDummy from "../../assets/avatares/avatar-dummy-violet.png";

import img1 from "../../assets/tests/scn3/img1-sc3-c2.png";

import { useVideoWithSound } from "../../hooks/useVideoWithSound";

function Scenario3Context3({ intl }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();

	const { videoRef, canPlayWithSound } = useVideoWithSound({ 
		autoPlay: true, 
		volume: 0.8
	});

	const [canOpenDialog, setCanOpenDialog] = useState(false);

	const transcription = "Entonces… ¿qué opciones tengo ahora?<br/>Después de todo lo que ya he pasado, imagino que no todas las opciones son iguales… ni todas estarán disponibles para mí.<br/>Yo solo sé que quiero un tratamiento que me dé tiempo, pero también que me permita seguir con mi vida, trabajar… sentirme útil.<br/>No sé cuál es el mejor camino, pero necesito que encaje conmigo, no solo con la enfermedad."

	const abrirModal = () => {
		if (videoRef.current) {
			videoRef.current.pause();
		}
		modalPresentacionManuel(transcription, manuelVideo, manuelVideoMp4, handleContinue, flechaAvanzar, canPlayWithSound, 0.8, "violet", true);
	};

	const handleContinue = () => {
		navigate(ROUTES.SCENARIO3_QUIZ2);
	};

	const activeScenario = getScenarioNumByPath(location.pathname);

	useEffect(() => {
		const timer = setTimeout(() => setCanOpenDialog(true), 35000);
		return () => clearTimeout(timer);
	}, []);

	return (
		<div className="h-100">
			<div className="container-fluid position-relative h-100">
				<div className="row h-100 d-flex align-items-center">
					<div className="col-md-4 d-flex flex-column justify-content-end h-100 px-4 pb-4">
						<video
							ref={videoRef}
							className="mb-4 pb-5"
							autoPlay
							playsInline
							preload="auto"
							muted
						>
							<source src={avatarVideoMp4}  type="video/mp4" />
							<source src={avatarVideo} type="video/webm" />
						</video>
					</div>

					{/* Columna derecha: espacio visual */}
					<div className="col-md-8 d-flex flex-column justify-content-top align-items-end bg-blur-violet h-100 px-5 pt-3">
						<div className="row recuadro-white recuadro-border-violet txtTexto1 mb-1 w-100 text-center">
							<h3 className="txtTitulos violet mb-2">
								Resultado de la patología
							</h3>
							<div className="col-md-12">
								<div>
									<img
										src={img1}
										alt="Adenocarcinoma de próstata. Gleason 4+5"
										style={{
											maxWidth: "60%",
											height: "auto",
										}}
									/>
								</div>
							</div>
							<div className="col-md-12">
								<div className="my-2 txt16">Adenocarcinoma de próstata. Gleason 4+5</div>
							</div>
						</div>
						<div className="mt-1 d-flex align-items-center justify-content-end w-100">
						{/* Botón siguiente */}
						<NextButton
							navigateTo={ROUTES.SCENARIO3_QUIZ2}
							activeScenario={activeScenario}
							color="violet"
							textColor="white"
						/>
						</div>
					</div>
				</div>
			</div>
			<ScenarioBar activeScenario={activeScenario} />
		</div>
	);
}

export default injectIntl(Scenario3Context3);
